import { StyleSheet, Switch, Text, View } from 'react-native'
import React, { useState } from 'react'

const SwitchOne = () => {
      //////SWITCH
  const toggleSwitch = () => setIsEnable((previousState) => !previousState);
  const [isEnable, setIsEnable] = useState(false);
  const toggleSwitched = () => setIsEnabled((previousState) => !previousState);
  const [isEnabled, setIsEnabled] = useState(false);
  return (
    <View >
    <Switch
    style={{width:50,height:50}}
    trackColor={{ false: 'rgba(143, 67, 0, 0.5)', true: "#9C4900" }}
    thumbColor={isEnabled ? "red" : "#EDDFE1"}
    ios_backgroundColor="#3e3e3e"
    onValueChange={toggleSwitch}
    value={isEnable}
  />
    </View>
  )
}

export default SwitchOne

const styles = StyleSheet.create({})